import type { TopicPart } from "../entities/TopicPart";
import {
    downloadTextAsFile,
    markdownFilenameFromTitle,
} from "../../../utils/downloadTextFile";
import { buildTopicPartMarkdown } from "./copyTopicPartContentUseCase";

export const downloadTopicPartContentUseCase = {
    exec(topicPart: TopicPart): void {
        const content = buildTopicPartMarkdown(topicPart);
        if (!content) return;

        downloadTextAsFile(
            content,
            markdownFilenameFromTitle(topicPart.title, "topic-part"),
        );
    },
};
